import { useSuspendedQuery, useZepApiClient } from '@zep/apis';
import { CountryCode, PlanStatus, PlanType, SpaceSimpleDto } from '@zep/types';

/**
 * @deprecated libs/service/apis/src/openapi의 최신 스키마로 업데이트 해주세요.
 */
export const useSpacePlanDetail = ({
  spaceHashId,
}: {
  spaceHashId: string;
}) => {
  const client = useZepApiClient();

  return useSuspendedQuery(['plan-space-detail', spaceHashId], async () => {
    const { data: planSpaceDetail } = await client.get<{
      status: number;
      statusKey: string;
      data: {
        space: Omit<SpaceSimpleDto, 'countryCode'> & {
          countryCode: CountryCode;
        };
        spacePlan?: {
          planType: PlanType;
          status: PlanStatus;
        };
      };
    }>('/v2/spaces/plans/detail', {
      params: {
        spaceHashId,
      },
    });

    return planSpaceDetail.data;
  });
};
